import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { roleGroupLabels } from '../../data/roles';
import { GroupBreakdown } from '../../hooks/useCompanyOverview';
import { RoleGroup } from '../../types/commission';
import { formatCurrency } from '../../utils/commission';
interface PositionBreakdownProps {
  groups: GroupBreakdown[];
  activeGroup: RoleGroup | 'All';
  onSelectGroup: (group: RoleGroup) => void;
}
const barColors: Record<RoleGroup, string> = {
  Production: 'bg-brand-600',
  Leadership: 'bg-gold-400',
  Operations: 'bg-slate-400'
};
export function PositionBreakdown({
  groups,
  activeGroup,
  onSelectGroup
}: PositionBreakdownProps) {
  return <section aria-labelledby="breakdown-heading" className="h-full rounded-xl border border-slate-200 bg-white p-6 shadow-card" data-id="element-151" data-mp="2cdoyq81q3qz7">
      <h2 id="breakdown-heading" className="text-base font-bold text-slate-900" data-id="element-152" data-mp="3sr5o4nd8zuig">
        By position group
      </h2>
      <p className="mt-0.5 text-sm text-slate-500" data-id="element-153" data-mp="3ns2hwzlj7i8w">Select a group to filter the people list</p>

      <div className="mt-4 flex h-2.5 overflow-hidden rounded-full bg-slate-100" aria-hidden="true" data-id="element-154" data-mp="277186mn7mt3d">
        {groups.map(group => <span key={group.group} className={barColors[group.group]} style={{
        width: `${group.share * 100}%`
      }} data-id="element-155" data-mp="2c909zs3axhy7" />)}
      </div>

      <ul className="mt-4 space-y-2" data-id="element-156" data-mp="2l83v11m147fc">
        {groups.map(group => {
        const isActive = activeGroup === group.group;
        return <li key={group.group} data-id="element-157" data-mp="1oj609jea49i6">
              <button type="button" aria-pressed={isActive} onClick={() => onSelectGroup(group.group)} className={`flex w-full items-center gap-3 rounded-lg border px-3.5 py-3 text-left transition ${isActive ? 'border-brand-300 bg-brand-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}`} data-id="element-158" data-mp="1tg66bub4pc9a">
                <span aria-hidden="true" className={`h-8 w-1.5 shrink-0 rounded-full ${barColors[group.group]}`} data-id="element-159" data-mp="19rnfz9edzst0" />
                <span className="min-w-0 flex-1" data-id="element-160" data-mp="2d21h4e0skala">
                  <span className="block text-sm font-semibold text-slate-900" data-id="element-161" data-mp="2849eoq2it62u">{roleGroupLabels[group.group]}</span>
                  <span className="block text-xs text-slate-500" data-id="element-162" data-mp="2mtnqe4tkjzle">
                    {group.headcount} {group.headcount === 1 ? 'person' : 'people'} · {Math.round(group.share * 100)}% of
                    total
                  </span>
                </span>
                <span className="text-sm font-bold tabular-nums text-slate-900" data-id="element-163" data-mp="1u6kvdmo3q6zw">{formatCurrency(group.commission)}</span>
                <ChevronRightIcon className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-164" data-mp="2356lq3zteqb8" />
              </button>
            </li>;
      })}
      </ul>
    </section>;
}